import { render, staticRenderFns } from "./DefaultEventsDayWidgetServer.vue?vue&type=template&id=3cf86cd6"
import script from "./DefaultEventsDayWidgetServer.vue?vue&type=script&lang=js"
export * from "./DefaultEventsDayWidgetServer.vue?vue&type=script&lang=js"
import style0 from "./DefaultEventsDayWidgetServer.vue?vue&type=style&index=0&id=3cf86cd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports